<form [formGroup]="pipSignature">
  <axis-card>
    <axis-card-body>
      <h1 class="axis-h3">
        {{ signatureData?.heading }}
      </h1>
      <div class="axis-h3">
        {{ signatureData?.instruction }}
      </div>

      <div class="axis-h5">{{ signatureData?.sectionTitle }}</div>

      @if (role == "insured") {
        <div
          class="axis-form-group has-axis-required"
          [ngClass]="{
            'has-axis-error': pipSignature.get('pipSignCheck')?.invalid && pipSignature.get('pipSignCheck').touched,
          }"
        >
          <axis-checkbox
            [heading]="signatureData?.authorization?.label"
            formControlName="pipSignCheck"
            [required]="true"
            class="kind-custom"
            ><span
              aria-hidden="true"
              class="axis-required-indicator"
              >*</span
            ></axis-checkbox
          >

          @if (pipSignature.get("pipSignCheck")?.invalid && pipSignature.get("pipSignCheck").touched) {
            <div class="axis-error-block">Please select check box.</div>
          }
        </div>
      }
      @if (role == "broker") {
        <div class="axis-form-group">
          <axis-checkbox
            [heading]="signatureData?.authorization?.label"
            formControlName="unSignCheck"
            [disabled]="true"
          ></axis-checkbox>
        </div>
      }

      @if (role == "insured") {
        <div
          class="axis-form-group"
          [ngClass]="{ 'has-axis-error': showSignatureError }"
        >
          <app-signature
            #signaturePad
            (signatureChange)="onSignatureChange()"
          />
          <div
            class="axis-error-block"
            *ngIf="showSignatureError"
          >
            Please Provide a Signature.
          </div>
        </div>
      }
      @if (role == "broker") {
        <div class="axis-h5">{{ signatureData?.signatureArea?.label }}</div>
      }
      <div class="axis-grid">
        <div class="axis-col-md-6 axis-col-xl-4">
          <div
            class="axis-form-group has-axis-required"
            [ngClass]="{
              'has-axis-error':
                (pipSignature.get('pipInsuredName').value === '' && pipSignature.get('pipInsuredName').touched) || pipSignature.get('pipInsuredName')?.errors?.['pattern'],
              'has-axis-required': pipSignature.get('pipInsuredName').value === '' || pipSignature.get('pipInsuredName')?.errors?.['pattern'],
            }"
          >
            <label
              class="axis-control-label"
              for="idSignatureText"
            >
              {{ signatureData?.nameAndTitle?.label }}
            </label>
            <input
              autocomplete="off"
              axis-input-clear
              class="axis-form-control"
              id="idSignatureText"
              type="text"
              formControlName="pipInsuredName"
            />
            @if (pipSignature.get("pipInsuredName").value === "") {
              <div class="axis-error-block">Please enter Name.</div>
            }
            @if(pipSignature.get("pipInsuredName")?.errors?.['pattern']){
             <div class="axis-error-block">Name and title should only contain letters , blank spaces and acceptable special characters</div> 
            }
          </div> 
        </div>
      </div>
      <p class="_text-bold">
        Please note: All signed forms will be available for download following your completion and affirmation of your
        selections, and the application of your signature to the forms.
      </p>
    </axis-card-body>
  </axis-card>
  <div class="axis-btn-wrapper">
    <div class="axis-btn-wrapper-left">
      <button
        axis-button
        class="kind-secondary"
        (click)="onBack()"
      >
        <span class="axis-btn-icon-text">Back</span>
      </button>
    </div>
    @if (role == "insured") {
      <div class="axis-btn-wrapper-right">
        <button
          axis-button
          class="kind-primary"
          (click)="onContinue()"
        >
          <span class="axis-btn-icon-text">Continue</span>
        </button>
      </div>
    }
  </div>
</form>
